import { type ResultOf } from '@graphql-typed-document-node/core'

import { type PathKey } from '~/apps/ninesegsAnalyzer/routes/paths'
import { graphql } from '~/gql'
import { type Brand, type Question } from '~/hooks/useSurveyQuery'
import {
  type ColumnInfo,
  type DiffKey,
  type DiffValue,
  type Group,
  type GroupAndAll,
  type NineSegment,
} from '~/utils'

const answerOptionFragment = graphql(`
  fragment GroupCountsFigures_AnswerOption on AnswerOption {
    option
    text
  }
`)
export type AnswerOption = ResultOf<typeof answerOptionFragment>

export const pathKey = 'customizedAnalysis' satisfies PathKey

export type ScrollHash = string

export type DisplayRowId = string // CustomerAttribute['id'] | `${Question['question_id']}-${AnswerOption['option']}`

export type DisplayColumnKey = Question['question_id']

export type GroupInfo = {
  brandNumber: Brand['number']
  nineSegment: NineSegment
  group: Group
}

export type GroupsDiff = DiffValue<GroupAndAll>
export type GroupsDiffColumnKey = DiffKey<GroupAndAll>

export type QuestionsDiff = DiffValue<Question['question_id']>
export type QuestionsDiffsMap = Record<Question['question_id'], QuestionsDiff[]>
export type QuestionsDiffColumnKey = DiffKey<Question['question_id']>

export type RowData<T extends string> = {
  counts: Record<T, number>
  ratios: Record<T, number>
}

export const getAnswerOptionRowId = (
  question: Question,
  answerOption: AnswerOption,
) => `${question.question_id}-${answerOption.option}`

export const getColumnInfos = <
  ColumnKey extends string,
  ColumnWidthKey extends ColumnKey,
>(
  columnKeys: ColumnKey[],
  widthMap: Record<ColumnWidthKey, string>,
): ColumnInfo<ColumnKey>[] =>
  columnKeys.map((key) => ({
    key,
    width: widthMap[key as ColumnWidthKey] ?? '5.5em',
  }))
